import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-flat-instructions-form',
  templateUrl: './flat-instructions-form.component.html'
})
export class FlatInstructionsFormComponent {
  @Input() options: FlatInstructionsOptions;
  @Input() treatment: FormGroup;

  public get flatInstructions(): FormGroup {
    return <FormGroup>this.treatment.get("flatInstructions");
  }

  public get substrate(): FormControl {
    return <FormControl>this.flatInstructions.get("substrate");
  }

  public get irrigation(): FormControl {
    return <FormControl>this.flatInstructions.get("irrigation");
  }

  public get fertigation(): FormControl {
    return <FormControl>this.flatInstructions.get("fertigation");
  }

  public get flatType(): FormControl {
    return <FormControl>this.flatInstructions.get("flatType");
  }

  public get directSeedToPots(): FormControl {
    return <FormControl>this.flatInstructions.get("directSeedToPots");
  }

  constructor() { }

  public copyValueFrom(copyArgs: FlatInstructionsCopyArgs) {
    this.flatInstructions.patchValue(copyArgs);
    this.flatInstructions.updateValueAndValidity();
  }
}

export interface FlatInstructionsCopyArgs {
  directSeedToPots: boolean;
  flatType: number;
  substrate: number;
  irrigation: number;
  fertigation: number;
}

export interface FlatInstructionsOptions {
  flatTypes: FlatTypeDisplay[];
  substrates: SubstrateDisplay[];
  irrigations: IrrigationDisplay[];
  fertigations: FertigationDisplay[];
}

export interface FlatTypeDisplay {
  id: number;
  display: string;
}

export interface SubstrateDisplay {
  id: number;
  display: string;
}

export interface IrrigationDisplay {
  id: number;
  display: string;
}

export interface FertigationDisplay {
  id: number;
  display: string;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/flat-instructions/flat-instructions-form/flat-instructions-form.component.ts